import axios from "axios";
import { toast } from "react-toastify";
import {
  CREATE_TERMINAL_SUBJECT,
  DELETE_TERMINAL_SUBJECT,
  GET_TERMINAL_SUBJECT,
  GET_TERMINAL_SUBJECT_DETAILS,
  UPDATE_TERMINAL_SUBJECT,
} from "../constants/Type";
import { BASE_URL } from "../constants/URL";
import { getGradeList } from "./Grade.action";

//GET TERMINAL SUBJECT LIST
export const getTerminalSubjectList = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/terminal-subject/${id}`);

    dispatch({
      type: GET_TERMINAL_SUBJECT,
      payload: res.data.data,
    });
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

//GET TERMINAL SUBJECT Details
export const getTerminalSubjectDetails = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${BASE_URL}/api/terminal-subject/${id}/details`
    );

    dispatch({
      type: GET_TERMINAL_SUBJECT_DETAILS,
      payload: res.data.data,
    });
  } catch (err) {
    toast.error(err.response.data.message);
  }
};

// CREATE TERMINAL SUBJECT
export const createTerminalSubject = (values) => async (dispatch) => {
  let formData = {
    name: values.name,
    gradeId: values.gradeId,
    oralMark: parseInt(values.oralMark),
    writingMark: parseInt(values.writingMark),
    mark: parseInt(values.mark),
    terms: values.terms.join(","), // Convert array to comma-separated string
    serial: parseInt(values.serial),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.post(
      `${BASE_URL}/api/terminal-subject`,
      JSON.stringify(formData),
      config
    );
    dispatch({
      type: CREATE_TERMINAL_SUBJECT,
      payload: res.data.data,
    });

    toast.success("Terminal Subject added successfully");

    dispatch(getGradeList());
    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// UPDATE TERMINAL SUBJECT
export const updateTerminalSubject = (values, id) => async (dispatch) => {
  let formData = {
    name: values.name,
    gradeId: values.gradeId,
    oralMark: parseInt(values.oralMark),
    writingMark: parseInt(values.writingMark),
    mark: parseInt(values.mark),
    terms: values.terms.join(","), // Convert array to comma-separated string
    serial: parseInt(values.serial),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.patch(
      `${BASE_URL}/api/terminal-subject/${id}`,
      JSON.stringify(formData),
      config
    );
    dispatch({
      type: UPDATE_TERMINAL_SUBJECT,
      payload: res.data.data,
    });
    dispatch(getGradeList());
    toast.success("Terminal Subject updated successfully");
    dispatch(getTerminalSubjectDetails(id));
    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// UPDATE TERMINAL SUBJECT SERIAL
export const updateTerminalSubjectSerial = (id, serial) => async (dispatch) => {
  let formData = {
    serial: parseInt(serial),
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const res = await axios.patch(
      `${BASE_URL}/api/terminal-subject/serial/${id}`,
      JSON.stringify(formData),
      config
    );
    dispatch({
      type: UPDATE_TERMINAL_SUBJECT,
      payload: res.data.data,
    });
    dispatch(getGradeList());
    toast.success("Terminal Subject serial updated successfully");
    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};

// DELETE TERMINAL SUBJECT
export const deleteTerminalSubject = (id) => async (dispatch) => {
  try {
    await axios.delete(`${BASE_URL}/api/terminal-subject/${id}`);
    dispatch({
      type: DELETE_TERMINAL_SUBJECT,
      payload: id,
    });
    toast.success("Terminal Subject deleted successfully");
    dispatch(getGradeList());
    return true;
  } catch (err) {
    toast.error(err.response.data.message);
    return false;
  }
};
